/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_Members_Manage_Extra_Seats_Increase_SeatsInputs */

const en_space_members_manage_extra_seats_increase_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase Seats`)
};

const de_space_members_manage_extra_seats_increase_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitze hinzufügen`)
};

const es_space_members_manage_extra_seats_increase_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar plazas`)
};

const fr_space_members_manage_extra_seats_increase_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des places`)
};

const nl_space_members_manage_extra_seats_increase_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaatsen verhogen`)
};

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */
const it_space_members_manage_extra_seats_increase_seats = en_space_members_manage_extra_seats_increase_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */
const pt_br2_space_members_manage_extra_seats_increase_seats = en_space_members_manage_extra_seats_increase_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */
const pl_space_members_manage_extra_seats_increase_seats = en_space_members_manage_extra_seats_increase_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */
const hu_space_members_manage_extra_seats_increase_seats = en_space_members_manage_extra_seats_increase_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs) => LocalizedString} */
const ro_space_members_manage_extra_seats_increase_seats = en_space_members_manage_extra_seats_increase_seats;

/**
* | output |
* | --- |
* | "Increase Seats" |
*
* @param {Space_Members_Manage_Extra_Seats_Increase_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const space_members_manage_extra_seats_increase_seats = /** @type {((inputs?: Space_Members_Manage_Extra_Seats_Increase_SeatsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Members_Manage_Extra_Seats_Increase_SeatsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "de") return de_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "es") return es_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "fr") return fr_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "nl") return nl_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "it") return it_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "pt-BR") return pt_br2_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "pl") return pl_space_members_manage_extra_seats_increase_seats(inputs)
	if (locale === "hu") return hu_space_members_manage_extra_seats_increase_seats(inputs)
	return ro_space_members_manage_extra_seats_increase_seats(inputs)
});
export { space_members_manage_extra_seats_increase_seats as "space.members.manage_extra_seats.increase_seats" }